var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", { staticClass: "icon", attrs: { src: _vm.icons.warning } }),
    _vm._v(" "),
    _c("h1", { staticClass: "account-verification__step__title" }, [
      _vm._v("\n    Are you sure to override verification?\n  "),
    ]),
    _vm._v(" "),
    _c("p", { staticClass: "account-verification__step__description" }, [
      _vm._v(
        "\n    Use of this function is recorded by Ring's Internal Security Team.\n  "
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "warning-container" }, [
      _c("table", { staticClass: "table" }, [
        _c("tr", [
          _c("td", [
            _c("img", {
              staticClass: "warning-container__icon__img",
              attrs: { src: _vm.icons.info },
            }),
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "table__title" }, [
            _vm._v("\n          Warning\n        "),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "override-buttons-container" },
      [
        _c(
          "el-button",
          {
            staticClass:
              "account-verification__step__button account-verification__step__button-white",
            attrs: { plain: "", type: "primary" },
            on: { click: _vm.cancelOverride },
          },
          [_vm._v("\n      " + _vm._s(_vm.cancelButtonText) + "\n    ")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            staticClass: "account-verification__step__button",
            attrs: { type: "primary" },
            on: { click: _vm.processOverride },
          },
          [_vm._v("\n      " + _vm._s(_vm.processButtonText) + "\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td"),
      _vm._v(" "),
      _c("td", { staticClass: "table__description" }, [
        _vm._v(
          "\n          This is a restricted function and should only be used when there is a business need.\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }